// extracted by mini-css-extract-plugin
export default {"wrapper":"vk","block":"wk","item":"xk"};